import { action, createRequestTypes } from "../../actions";

export const LOAD_TREATMENTS = createRequestTypes("LOAD_TREATMENTS");
export const UPDATE_TREATMENT = createRequestTypes("UPDATE_TREATMENT");
export const CANCEL_TREATMENT = createRequestTypes("CANCEL_TREATMENT");
export const CREATE_TREATMENT = createRequestTypes("CREATE_TREATMENT");
export const RESCHEDULE_TREATMENT = createRequestTypes("RESCHEDULE_TREATMENT");
export const TOGGLE_IN_SESSION = "TOGGLE_IN_SESSION";
export const SAVE_TREATMENT = "SAVE_TREATMENT";
export const CLEAR_TREATMENT = "CLEAR_TREATMENT";

export const toggleInSession = inSession => action(TOGGLE_IN_SESSION, inSession);

export const saveTreatment = treatment => action(SAVE_TREATMENT, treatment);
export const clearTreatment = () => action(CLEAR_TREATMENT);

export const loadTreatments = {
  request: (filters) => action(LOAD_TREATMENTS.REQUEST, filters),
  success: (response) => action(LOAD_TREATMENTS.SUCCESS, { response, reset: true, resetKey: "treatments" }),
  failure: (error) => action(LOAD_TREATMENTS.FAILURE, { error }),
};

export const createTreatment = {
  request: (treatment) => action(CREATE_TREATMENT.REQUEST, { treatment }),
  success: (response) => action(CREATE_TREATMENT.SUCCESS, { response }),
  failure: (error) => action(CREATE_TREATMENT.FAILURE, error),
};

export const updateTreatment = {
  request: (treatmentId, treatment) => action(UPDATE_TREATMENT.REQUEST, { treatmentId, treatment }),
  success: (response) => action(UPDATE_TREATMENT.SUCCESS, { response }),
  failure: (error) => action(UPDATE_TREATMENT.FAILURE, error),
};

export const rescheduleTreatment = {
  request: (treatmentId, treatment) => action(RESCHEDULE_TREATMENT.REQUEST, { treatmentId, treatment }),
  success: (response) => action(RESCHEDULE_TREATMENT.SUCCESS, { response }),
  failure: (error) => action(RESCHEDULE_TREATMENT.FAILURE, error),
};

export const cancelTreatment = {
  request: (treatmentId, treatment) => action(CANCEL_TREATMENT.REQUEST, { treatmentId, treatment }),
  success: (response) => action(CANCEL_TREATMENT.SUCCESS, { response }),
  failure: (error) => action(CANCEL_TREATMENT.FAILURE, error),
};
